/**
 * TabShell — layout shell for the three main tab routes (Home, Course, Me).
 *
 * Renders:
 *   1. The child route content via <Outlet />.
 *   2. The NavTabs bar fixed to the bottom.
 *
 * Each tab's content is responsible for its own CosmosBackdrop and
 * padding. TabShell only provides the bottom offset so content doesn't
 * clip behind the NavBar.
 *
 * Usage in App.tsx:
 *   <Route element={<TabShell />}>
 *     <Route path="/home"    element={<Home />} />
 *     <Route path="/course"  element={<CoursePage />} />
 *     <Route path="/me"      element={<Me />} />
 *   </Route>
 */

import { Outlet, useMatch } from 'react-router-dom';
import { useMe } from '../../hooks/useMe';
import { NavTabs } from './NavTabs';
import styles from './TabShell.module.css';

export function TabShell(): JSX.Element {
  const onCourse = useMatch('/course') !== null; // also matches /course/
  const { data: me } = useMe();
  // A course link opens /course before onboarding: no tabs yet, its back button leads to the normal start.
  const showTabs = !onCourse || (me?.onboardingStep ?? 0) >= 99;
  return (
    <div className={styles.shell}>
      {/* Route content */}
      <div className={styles.content}>
        <Outlet />
      </div>

      {/* Fixed bottom navigation */}
      {showTabs && <NavTabs />}
    </div>
  );
}
